import * as actionTypes from "./constants";
import axios from "axios";
import moment from "moment";
import {
  setSuccessMessage,
  setWarningMessage,
  setErrorMessage
} from "../../messages/actions";
import { setDates } from "./dateRangePicker/actions";
import { selectRooms } from "./roomPicker/actions";

export const setCleaner = cleaner => ({
  type: actionTypes.SET_CLEANER,
  cleaner
});

export const loadCleaningId = id => ({
  type: actionTypes.LOAD_CLEANING_ID,
  id
});

export const loadFresh = () => ({
  type: actionTypes.LOAD_FRESH
});

export const loadCleaning = cleaning => {
  return (dispatch, getState) => {
    const { data } = getState().rooms;
    const selectedRooms = data.filter(room =>
      cleaning.rooms.find(r => r.roomId === room.roomId)
    );
    dispatch(loadFresh());
    dispatch(loadCleaningId(cleaning._id));
    dispatch(setCleaner(cleaning.userId));
    dispatch(setDates(moment.utc(cleaning.from), moment.utc(cleaning.to)));
    dispatch(selectRooms(selectedRooms));
  };
};

export const saveCleaning = cb => {
  return (dispatch, getState) => {
    const {
      dateRangePicker,
      roomPicker,
      selectedCleaner,
      selectedCleaning
    } = getState().scheduleCleaning;
    const { socket } = getState().messages;
    const hotelId = getState().hotels.selected;

    const cleaning = {
      userId: selectedCleaner,
      hotelId,
      from: dateRangePicker.dateFrom,
      to: dateRangePicker.dateTo,
      rooms: roomPicker.selected.map(r => ({ roomId: r.roomId }))
    };

    if (!validate(cleaning, dispatch)) return;

    if (selectedCleaning !== "") {
      cleaning._id = selectedCleaning;
      dispatch({
        type: actionTypes.UPDATE_CLEANING_REQUEST
      });
      return axios
        .put(`/cleaning/${selectedCleaning}`, cleaning)
        .then(response => {
          dispatch({
            type: actionTypes.UPDATE_CLEANING_SUCCESS,
            cleaning
          });
          socket.emit("cleaning:update", cleaning);
          cb();
        })
        .catch(err => {
          dispatch({
            type: actionTypes.UPDATE_CLEANING_REJECT
          });
          dispatch(
            setErrorMessage(err.response ? err.response.data : err.data)
          );
        });
    } else {
      dispatch({
        type: actionTypes.CREATE_CLEANING_REQUEST
      });
      return axios
        .post("/cleaning", cleaning)
        .then(response => {
          dispatch({
            type: actionTypes.CREATE_CLEANING_SUCCESS,
            cleaning: response.data
          });
          socket.emit("cleaning:schedule", response.data);
          cb();
          dispatch(setSuccessMessage("cleaning:cleaningSavedText"));
        })
        .catch(err => {
          dispatch({
            type: actionTypes.CREATE_CLEANING_REJECT
          });
          dispatch(
            setErrorMessage(err.response ? err.response.data : err.data)
          );
        });
    }
  };
};

const validate = (cleaning, dispatch) => {
  if (cleaning.userId === "") {
    dispatch(setWarningMessage("cleaning:selectselectCleanerText"));
    return false;
  } else if (!cleaning.from) {
    dispatch(setWarningMessage("cleaning:selectStartDateText"));
    return false;
  } else if (!cleaning.to) {
    dispatch(setWarningMessage("cleaning:selectEndDateText"));
    return false;
  } else if (cleaning.rooms.length === 0) {
    dispatch(setWarningMessage("cleaning:selectRoomText"));
    return false;
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/cleaning/schedule/actions.js